import { sendWebsocketMessage } from '../../../../../../../App';

export function modifyPct(tradePlanId, tacticId, target, pctQty) {
  const msg = {
    messageType: 'updateTradePlan',
    tradePlanId,
    field: 'softOrder',
    value: {
      pluginId: tacticId,
      plugin: 'CANDLE_MAGNITUDE',
      details: { modifyQty: { target, pctQty } },
    },
  };
  sendWebsocketMessage(msg);
}
